<template>

    <div class="border-b border-theme-level2 bg-theme-level4">

        <div id="hero-content-container" class="hero-section bg-theme-level4 cursor-pointer pr-6" :style="heroContentStyling">

            <!--<div class="flex-1"></div>-->

            <div class="mainSection flex-grow flex-no-shrink" style="min-width: 500px; max-height: 395px;">

                <div class="w-full h-full flex" style="max-height: 395px; min-height: 280px;">

                    <hero-video-player :currentlocale="currentlocale"
                                       :herocontent="herocontent" style="max-height: 395px;"></hero-video-player>

                </div>

            </div>

            <div class="hero-section-grow dataSection flex flex-col px-6 py-10" style="min-width: 340px; max-width: 400px;" @click="showPlayerForHero">

                <p class="text-theme-title text-lg leading-tight font-bold mb-2">{{ this.heroContent.title }}</p>

                <div class="flex-1" style="max-height: 20px;"></div>

                <div class="">
                    <p class="text-xs text-theme-main leading-normal">{{ heroTextContent }}</p>
                </div>

                <div class="flex-1"></div>

                <span class="text-xs text-theme-discrete flex flex-row items-center mb-2">
                    <i class="material-icons mr-2" style="font-size: 16px;">event_note</i>
                    <span class="flex-1">{{ translate('published-on') }} <span v-text="date"></span>, {{ translate('at') }} <span v-text="time"></span></span>
                </span>

                <div class="flex flex-row">

                    <div class="mr-1">

                        <!-- FACEBOOK -->
                        <span @click.stop="">
                                    <ShareNetwork
                                        network="facebook"
                                        :url="shareableLinkCode"
                                        :title="heroContent.title"
                                        :description="heroContent.abstract"
                                    >
                                        <i class="material-icons mr-1 pl-1 pt-1 icon-circled cursor-pointer text-theme-discrete hover:text-theme-main" style="height: 30px; width: 30px;">
                                            <svg class="inline-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20px" height="20px">
                                                <path d="M17.525,9H14V7c0-1.032,0.084-1.682,1.563-1.682h1.868v-3.18C16.522,2.044,15.608,1.998,14.693,2 C11.98,2,10,3.657,10,6.699V9H7v4l3-0.001V22h4v-9.003l3.066-0.001L17.525,9z"/>
                                            </svg>
                                        </i>
                                    </ShareNetwork>
                                </span>

                        <!-- TWITTER -->
                        <span @click.stop="">
                                    <ShareNetwork
                                        network="twitter"
                                        :url="shareableLinkCode"
                                        :title="heroContent.title"
                                        hashtags="telesurtv"
                                        twitter-user="telesurtv"
                                    >
                                        <i class="material-icons mr-1 pl-1 pt-1 icon-circled cursor-pointer text-theme-discrete hover:text-theme-main" style="height: 30px; width: 30px;">
                                            <svg class="inline-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28 28" width="20px" height="20px">
                                                <path d="M28,6.937c-0.957,0.425-1.985,0.711-3.064,0.84c1.102-0.66,1.947-1.705,2.345-2.951c-1.03,0.611-2.172,1.055-3.388,1.295 c-0.973-1.037-2.359-1.685-3.893-1.685c-2.946,0-5.334,2.389-5.334,5.334c0,0.418,0.048,0.826,0.138,1.215 c-4.433-0.222-8.363-2.346-10.995-5.574C3.351,6.199,3.088,7.115,3.088,8.094c0,1.85,0.941,3.483,2.372,4.439 c-0.874-0.028-1.697-0.268-2.416-0.667c0,0.023,0,0.044,0,0.067c0,2.585,1.838,4.741,4.279,5.23 c-0.447,0.122-0.919,0.187-1.406,0.187c-0.343,0-0.678-0.034-1.003-0.095c0.679,2.119,2.649,3.662,4.983,3.705 c-1.825,1.431-4.125,2.284-6.625,2.284c-0.43,0-0.855-0.025-1.273-0.075c2.361,1.513,5.164,2.396,8.177,2.396 c9.812,0,15.176-8.128,15.176-15.177c0-0.231-0.005-0.461-0.015-0.69C26.38,8.945,27.285,8.006,28,6.937z"/>
                                            </svg>
                                        </i>
                                    </ShareNetwork>
                                </span>

                        <!-- WHATSAPP -->
                        <span @click.stop="">
                                    <ShareNetwork
                                        network="whatsapp"
                                        :url="shareableLinkCode"
                                        :title="heroContent.title"
                                        :description="heroContent.abstract"
                                    >
                                        <i class="material-icons mr-1 pt-1 icon-circled cursor-pointer text-theme-discrete hover:text-theme-main" style="height: 30px; width: 30px; padding-left: 6px;">
                                            <svg class="inline-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20px" height="20px">
                                                <path d="M19.077,4.928C17.191,3.041,14.683,2.001,12.011,2c-5.506,0-9.987,4.479-9.989,9.985 c-0.001,1.76,0.459,3.478,1.333,4.992L2,22l5.233-1.237c1.459,0.796,3.101,1.215,4.773,1.216h0.004 c5.505,0,9.986-4.48,9.989-9.985C22.001,9.325,20.963,6.816,19.077,4.928z M16.898,15.554c-0.208,0.583-1.227,1.145-1.685,1.186 c-0.458,0.042-0.887,0.207-2.995-0.624c-2.537-1-4.139-3.601-4.263-3.767c-0.125-0.167-1.019-1.353-1.019-2.581 S7.581,7.936,7.81,7.687c0.229-0.25,0.499-0.312,0.666-0.312c0.166,0,0.333,0,0.478,0.006c0.178,0.007,0.375,0.016,0.562,0.431 c0.222,0.494,0.707,1.728,0.769,1.853s0.104,0.271,0.021,0.437s-0.125,0.27-0.249,0.416c-0.125,0.146-0.262,0.325-0.374,0.437 c-0.125,0.124-0.255,0.26-0.11,0.509c0.146,0.25,0.646,1.067,1.388,1.728c0.954,0.85,1.757,1.113,2.007,1.239 c0.25,0.125,0.395,0.104,0.541-0.063c0.146-0.166,0.624-0.728,0.79-0.978s0.333-0.208,0.562-0.125s1.456,0.687,1.705,0.812 c0.25,0.125,0.416,0.187,0.478,0.291C17.106,14.471,17.106,14.971,16.898,15.554z"/>
                                            </svg>
                                        </i>
                                    </ShareNetwork>
                                </span>

                        <!-- YOUTUBE -->
                        <span @click.stop="">
                                        <!--<i class="material-icons mr-1 pl-1 pt-1 icon-circled text-theme-discrete hover:text-theme-main" style="height: 30px; width: 30px;">-->
                                        <i class="material-icons mr-1 pl-1 pt-1 text-theme-discrete opacity-25 cursor-default" style="height: 30px; width: 30px;" @click.stop="">
                                            <svg class="inline-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20px" height="20px">
                                                <path d="M21.582,6.186c-0.23-0.86-0.908-1.538-1.768-1.768C18.254,4,12,4,12,4S5.746,4,4.186,4.418 c-0.86,0.23-1.538,0.908-1.768,1.768C2,7.746,2,12,2,12s0,4.254,0.418,5.814c0.23,0.86,0.908,1.538,1.768,1.768 C5.746,20,12,20,12,20s6.254,0,7.814-0.418c0.861-0.23,1.538-0.908,1.768-1.768C22,16.254,22,12,22,12S22,7.746,21.582,6.186z M10,15.464V8.536L16,12L10,15.464z"/>
                                            </svg>
                                        </i>
                                </span>

                        <!-- SHAREABLE LINK -->
                        <span @click.stop="getShareableLink">
                                    <i class="material-icons mr-1 pl-1 pt-1 icon-circled text-theme-discrete hover:text-theme-main cursor-pointer" style="height: 30px; width: 30px;">
                                        <svg class="inline-svg-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="20px" height="20px">
                                            <path d="M21,12L14,5V9C7,10 4,15 3,20C5.5,16.5 9,14.9 14,14.9V19L21,12Z" />
                                        </svg>
                                    </i>
                                </span>

                    </div>

                    <i v-if="downloadable" class="material-icons mt-0 mr-2 pl-1 pt-1 cursor-pointer icon-circled text-theme-discrete hover:text-theme-main" style="width: 30px; height: 30px;" @click.stop="downloadContent">get_app</i>
                    <i v-else class="material-icons mt-0 mr-2 pl-1 pt-1 icon-circled text-theme-discrete opacity-25 cursor-default" style="width: 30px; height: 30px;" @click.stop="">get_app</i>
                </div>


            </div>

            <!--<div class="flex-1" style="max-width: 250px;"></div>-->

            <div class="moreSection invisible xl:visible flex flex-col justify-around items-center" style="min-width: 300px; max-width: 320px;">

                <div class="flex flex-col">

                    <div v-for="(content, index) in JSON.parse(extra_links)" v-bind:key="content.id"
                         class="bg-theme-level2 text-sm text-theme-main mt-4 mb-2 mr-6 pr-4 flex flex-row items-center w-full cursor-pointer"
                         style="min-width: 300px; max-width: 320px;"
                         @click.stop="showExtraLinkPlayer(index)">
                        <img :src="cloudSource + content.thumbnail_url" alt="" style="height: 70px;">
                        <p class="ml-4">{{ content.title }}</p>
                    </div>

                    <div v-if="complementary_content" v-for="(content, index) in JSON.parse(complementary_content)" v-bind:key="content.id"
                         class="bg-theme-level2 text-sm text-theme-main mt-4 mb-2 mr-6 pr-4 flex flex-row items-center w-full cursor-pointer"
                         style="min-width: 300px; max-width: 320px;"
                         @click.stop="showComplementaryPlayer(index)">
                        <img :src="cloudSource + content.thumbnail_url" alt="" style="height: 70px;">
                        <p class="ml-4">{{ content.title }}</p>
                    </div>

                </div>

                <!--<div class="bg-theme-level2 text-sm p-8 text-theme-main mt-4 mb-2">Additional Content Area</div>
                <div class="bg-theme-level2 text-sm p-8 text-theme-main mb-2">Additional Content Area</div>
                <div class="bg-theme-level2 text-sm p-8 text-theme-main mb-4">Additional Content Area</div>-->

            </div>

            <!--<div class="flex-1"></div>-->

        </div>

        <div v-if="shareableLinkPanelVisible" class="fixed w-full flex flex-col items-center justify-center" style="background-color: rgba(0,0,0,0.75); top: 0; left: 0; z-index: 9999; height: 100vh;">
            <div class="bg-theme-level3 rounded-lg shadow-2xl p-6 flex flex-col" style="width: 38rem; height: 16rem;">
                <span class="text-base text-theme-main font-bold mb-4">{{  translate('share-link-title') }}</span>
                <span class="text-sm text-theme-discrete font-bold mb-10">{{ translate('share-link-description') }}</span>
                <div class="text-sm text-theme-discrete mb-12">
                    <code>{{ shareableLinkCode }}</code>
                </div>
                <div class="flex flex-row items-center justify-center">
                    <button class="flex flex-row items-center justify-center text-base text-theme-control-label rounded-lg px-4 w-32 h-10"
                            :class="{'bg-theme-controls2 hover:bg-theme-controls1': !shareableLinkWasCopied && !shareableLinkHadError, 'bg-green-500 hover:bg-green-500': shareableLinkWasCopied, 'bg-red-500 hover:bg-red-500': shareableLinkHadError}"
                            @click.stop="copyLinkToClipboard">
                        {{ copy_label }}
                    </button>
                    <button class="ml-2 flex flex-row items-center justify-center text-base bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label rounded-lg px-4 w-32 h-10"
                            @click.stop="shareableLinkPanelVisible=false">
                        {{ translate('close') }}
                    </button>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        props: [
            'currentlocale',
            'herocontent',
            'extra_links',
            'complementary_content',
            'bkg_urls'
        ],

        data() {

            return {

                heroContent: JSON.parse(this.herocontent),

                shareableLinkPanelVisible: false,
                shareableLinkWasCopied: false,
                shareableLinkHadError: false,
                copy_label: this.translate('copy'),

                ENV_CloudFront_Legacy_DNS_Name: process.env.MIX_LEGACY_CLOUDFRONT_DNSNAME,
                ENV_CloudFront_DNS_Name: process.env.MIX_CLOUDFRONT_DNSNAME,
                ENV_CloudFront_LegacyThumbnails_DNS_Name: process.env.MIX_LEGACY_THUMBNAILS_CLOUDFRONT_DNSNAME,
                ENV_Thumbnail_Key: process.env.MIX_BASE_THUMBNAIL_KEY

            }

        },


        computed: {

            date() {
                return this.heroContent.publish_date.split(' ')[0]
            },

            time() {
                return this.heroContent.publish_date.split(' ')[1]
            },

            cloudSource() {

                if(this.heroContent.legacy) {
                    return this.ENV_CloudFront_LegacyThumbnails_DNS_Name;
                } else {
                    return this.ENV_CloudFront_DNS_Name;
                }

            },

            thumbnailURL() {

                if(this.heroContent.legacy) {
                    return this.cloudSource + this.heroContent.thumbnail_url;
                } else {
                    return this.cloudSource + this.heroContent.thumbnail_url;
                }

            },

            shareableLinkCode() {

                return 'https://' + window.location.hostname + '/' + this.currentlocale + '/content/' + this.heroContent.id;

            },

            downloadable() {

                return this.heroContent.restrictions === 'Abierto' || this.heroContent.restrictions === 'Open';

            },

            heroTextContent() {

                if(this.heroContent.hero_text) {
                    return this.heroContent.hero_text;
                } else {
                    return this.heroContent.abstract.substring(0, 100) + '...';
                }

            },

            heroContentStyling() {

                let background = '';
                let suffix = this.$root.shared.theme === 'theme-dark' ? '_dark.jpg' : '_light.jpg';

                if(this.heroContent.hero_background===3) {
                    if(this.$root.shared.theme==='theme-light') {
                        background = 'url(' + this.ENV_CloudFront_DNS_Name + this.heroContent.filename + '/' + this.ENV_Thumbnail_Key + this.heroContent.hero_background_image + '.jpg' + ')';
                    } else {
                        background = 'url(' + this.ENV_CloudFront_DNS_Name + this.heroContent.filename + '/' + this.ENV_Thumbnail_Key + this.heroContent.hero_background_image_dark + '.jpg' + ')';
                    }
                } else {
                    background = 'url(' + JSON.parse(this.bkg_urls)[this.heroContent.hero_background] + suffix + ')'
                }

                /*console.log('Returning as Background URL: ' + background);*/

                return {
                    'background-size': 'contain',
                    'background-image': background,
                    'background-repeat': 'no-repeat',
                    'max-height': '395px',
                    'max-width': '1400px'
                }

            },

        },

        methods: {

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

            getShareableLink() {
                this.shareableLinkPanelVisible=true;
            },

            setCopyLabelOk() {
                this.copy_label = this.translate('copied');
            },

            setCopyLabelError() {
                this.copy_label = 'Error!';
            },

            copyLinkToClipboard() {

                this.$copyText(this.shareableLinkCode).then((e) => {
                    this.setCopyLabelOk();
                    this.shareableLinkWasCopied=true;
                    console.log(e);
                }, (e) => {
                    this.setCopyLabelError();
                    this.shareableLinkHadError=true;
                    console.log(e)
                })
            },

            downloadContent() {
                if(this.heroContent.legacy) {
                    window.location=process.env.MIX_CLOUDFRONT_LEGACY_DNSNAME + this.heroContent.filename;
                } else {
                    window.location=process.env.MIX_CLOUDFRONT_DNSNAME + this.heroContent.filename + '/' + this.heroContent.filename + '.mp4';
                }
            },

            showPlayerForHero() {

                // console.log(JSON.stringify(this.heroContent));

                Event.fire('showPlayer', { language: this.currentlocale, data: this.heroContent });

            },

            showExtraLinkPlayer(content) {

                // console.log(JSON.stringify(JSON.parse(this.extra_links)[content]));
                Event.fire('showPlayer', { language: this.currentlocale, data: JSON.parse(this.extra_links)[content] });

            },

            showComplementaryPlayer(content) {

                Event.fire('showPlayer', { language: this.currentlocale, data: JSON.parse(this.complementary_content)[content] })

            }

        },

    }

</script>

<style>

    .hero-section {

        display: flex;
        flex-flow: row;

        /*min-height: 250px;
        max-height: 325px;*/

        /*display: grid;
        grid-template-columns: repeat(11, minmax(90px, 1fr));
        grid-template-rows: minmax(250px, min-content);
        grid-template-areas:
            "main main main main main data data data data more more";*/
    }

    .hero-section-grow {
        flex: 1 1 auto;
    }

    .mainSection {
        /*grid-area: main;*/
    }

    .dataSection {
        /*grid-area: data;*/
    }

    .moreSection {
        /*grid-area: more;*/
    }

    .inline-svg-icon {
        fill: var(--txt-discrete);
    }

    .inline-svg-icon:hover {
        fill: var(--txt-main);
    }

    .text-concat {
        max-width: 400px;
        overflow: hidden;
        /*padding: 20px;*/
        /*background: #eaeaea;*/
        /*margin: 50px auto;*/
        /*position: relative;
        display: inline-block;
        word-wrap: break-word;
        overflow: hidden;
        max-height: 3.2em;
        line-height: 1.6em;*/
    }

    .text .ellipsis ::after {
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        /*content: "...";
        position: absolute;
        right: -12px;
        bottom: 4px;*/
    }


    /*.this-player-fit {
        position: relative !important;
        width: 100% !important;
        max-height: 480px;
        !*height: auto !important;*!
    }*/

</style>
